export default __webpack_public_path__ + "images/pointer.e37bb7182a3a4373c4fb8abcd844017d.png";